export const infoData = [
  {
    id: 'id1',
    icon: 'bx-award',
    title: 'Experience',
    subtitle: '9+ Years Working',
  },
  {
    id: 'id2',
    icon: 'bx-briefcase-alt',
    title: 'Completed',
    subtitle: '100+ Projects',
  },
  {
    id: 'id3',
    icon: 'bx-user-plus',
    title: 'Clients',
    subtitle: '70+ Worldwide',
  },
  {
    id: 'id4',
    icon: 'bx-rocket',
    title: 'Deployed',
    subtitle: '60+ Apps',
  },
];
